import { Reveal } from "@/components/Reveal";

export const PageShell = ({ eyebrow, title, intro, children, testId }) => (
  <div className="relative overflow-hidden" data-testid={testId}>
    <div className="starfield opacity-60" aria-hidden />
    <div aria-hidden className="grid-lines pointer-events-none absolute inset-x-0 top-0 h-[520px] opacity-60" />
    <div aria-hidden className="pointer-events-none absolute left-[-10%] top-[-140px] h-[480px] w-[620px] max-w-[140vw] rounded-full bg-blue/20 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-5 pb-24 pt-16 sm:px-8 sm:pt-20 lg:pb-32">
      <Reveal className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <p className="mono-label">Xpattern // {eyebrow}</p>
          <h1 className="display mt-5 text-5xl text-white sm:text-6xl lg:text-8xl">{title}</h1>
        </div>
        {intro && <p className="max-w-md text-base leading-relaxed text-muted lg:col-span-5 lg:pb-3">{intro}</p>}
      </Reveal>
      <div className="mt-14 lg:mt-20">{children}</div>
    </div>
  </div>
);
